import React from "react";
import {
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from "@mui/material";

const FlavorVisibilitySelector = ({ formData, setFormData }) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography fontWeight={600} mb={1}>
        Visibility
      </Typography>
      <FormControl fullWidth>
        <InputLabel>Visibility</InputLabel>
        <Select
          value={formData.visibility}
          label="Visibility"
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, visibility: e.target.value }))
          }>
          <MenuItem value="public">Public</MenuItem>
          <MenuItem value="admin">Admin Only</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default FlavorVisibilitySelector;
